var tabs = {

	init: function () {
		$('.m-tabs:not(.js-tabs-done)').each(function () {
			var wrapper = $(this);
			var tabLinks = wrapper.find('.js-link');
			var tabContent = wrapper.find('.js-tab');

			// change
			function _change(element, scroll) {
				var isLink = element.prop('nodeName').toLowerCase() === 'a';
				var id = isLink ? element.attr('href') : ('#' + element.attr('aria-controls'));
				var newTab = wrapper.find(id);
				// links
				if (isLink) {
					tabLinks.removeClass('active').filter('[href="' + id + '"]').addClass('active');
				} else {
					tabLinks.removeClass('active').attr('aria-expanded', false).filter('[aria-controls="' + id.replace("#", "") + '"]').addClass('active').attr('aria-expanded', true);
				}
				// content
				tabContent.hide();
				newTab.show();
				// scroll
				if (scroll && site) {
					var content = $('#content');
					site.scrollTo((content.length ? content : newTab).offset().top);
				}
			}

			// load
			var activeTabAttr = wrapper.data('active-tab');
			var activeTabLink = activeTabAttr ? tabLinks.filter('[href="' + CSS.escape(activeTabAttr) + '"]') : $();
			if (activeTabLink.length) {
				_change(activeTabLink, false);
			} else if (tabLinks.filter('.active').length == 1) {
				_change(tabLinks.filter('.active'), false);
			} else {
				_change(tabLinks.first(), false);
			}

			// links
			tabLinks.off('click').on('click', function () {
				var link = $(this);
				if (!link.is('.active')) {
					_change(link, true);
				}
				return false;
			});

			// done
			wrapper.addClass('js-tabs-done');
		});
	}

};

$(function () {
	tabs.init();
	$(document).ajaxComplete(function () {
		tabs.init();
	});
});
